export const productMessaging = {
  name: 'Simcarlo',
  category: 'visual Monte Carlo profitability modeling',
  shortDescription: 'Build financial models visually, test thousands of scenarios, and compare outcomes with confidence.',
  primaryCta: 'Start modeling',
  workspaceCta: 'Open workspace',
  simulationLibrarySubtitle: 'Choose a model, compare scenarios, or start from an example.',
  auth: {
    loginTitle: 'Continue modeling uncertainty',
    loginSubtitle: 'Sign in to open your profitability models.',
    signupTitle: 'Start modeling uncertainty',
    signupSubtitle: 'Build your first visual Monte Carlo profitability simulation.',
    signupDescription: 'Create models with inputs, formulas, outputs, and scenarios without spreadsheet fragility.'
  },
  emptyStates: {
    graphTitle: 'Start with the structure of the decision',
    graphBody: 'Add uncertain inputs, connect formulas, then mark the outputs that matter for the decision.',
    resultsTitle: 'Results appear when your model has outputs',
    resultsBody: 'Mark profit, cost, revenue, or KPI nodes as outputs, then run the simulation to compare likely outcomes.',
    simulationsTitle: 'Build your first profitability model',
    simulationsBody: 'Create a blank model, import JSON, or open an example to inspect a finished workflow.',
    noOutputsTitle: 'No output metrics yet',
    noOutputsBody: 'Mark a profit, cost, revenue, or KPI node as an output to track the result here.',
    noRunTitle: 'Ready for output metrics',
    noRunBody: 'Run a simulation to populate percentiles, means, and scenario comparisons for your output nodes.',
    filteredOutputsTitle: 'No outputs downstream of this selection',
    filteredOutputsBody: 'Clear the selected node or choose an upstream driver that feeds an output KPI.'
  },
  assistantPrompts: {
    emptyGraph: [
      'Draft a simple profitability model',
      'Add revenue and cost drivers',
      'Create inputs, formulas, and a profit output'
    ],
    noOutputs: [
      'Suggest output KPIs for this model',
      'Find formulas that should be marked as outputs'
    ],
    hasResults: [
      'Explain the main sensitivity drivers',
      'Find weak assumptions in this model'
    ],
    scenarios: [
      'Compare active scenario to baseline',
      'Suggest a downside scenario'
    ]
  }
} as const;

export type AssistantPromptGroup = keyof typeof productMessaging.assistantPrompts;
